/* eslint-disable max-len */
import { memo, useState } from "react";
import { Popup } from "@/components/popups/Popup";
import { INITIAL_STEP, SUCCESS_STEP, CREATE_STEP } from "./constants";
import { CreateForm } from "./CreateForm";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import "./styles/CreateNichePopup.scss";

interface ICreateNichePopup {
  isOpen: boolean;
  onClose: () => void;
}

interface StepMap {
  [key: string]: {
    title: string | undefined;
    render: () => JSX.Element;
    btnProps: {
      variant?: number;
      title?: string;
      onClick?: () => void;
    };
  };
}

export const CreateNichePopup = memo((props: ICreateNichePopup) => {
  const [step, setStep] = useState(INITIAL_STEP);
  const { isOpen, onClose } = props;

  const renderNicheInfo = () => (
    <div className="CreateNichePopup-NicheInfo">
      <p>Niches are Public Communities where RedGIFs users can collect and collate content all around a specific theme. The NSFW world is a varied and exciting one and we want to ensure RedGIFs represents all corners of this incredible community.</p>
      <div>
        <h3>Submitting your Niche</h3>
        <p>On the next screen you'll be asked to give your new Niche a name as well as a description and posting guidelines to let the RedGIFs community know exactly the type of content your Niche is created for.</p>
      </div>
      <div>
        <h3>What Happens Next?</h3>
        <p>Our Niche Team reviews each submission manually to ensure our <Link to={routes.guidelines()}>Community Guidelines</Link> are followed as well as ensuring the Niche has an appropriate name and description. This ensures contributors and viewers can enjoy your Niche to the maximum extent!</p>
      </div>
      <p>Please click Continue to enter the details of your niche.</p>
    </div>
  );

  const renderNicheSuccess = () => (
    <div className="CreateNichePopup-NicheSuccess">
      <p>Congratulations! Your niche has been submitted  to our community team for review.</p>
      <p>Due to the popularity of niches, the review process can take up to 48 hours, so please wait at least two days before following up on your submission.</p>
      <p>Thanks again for your interest in creating a new niche on RedGIFs!</p>
    </div>
  );

  const stepMap: StepMap = {
    [INITIAL_STEP]: {
      title: "Create a Niche",
      render: () => renderNicheInfo(),
      btnProps: {
        variant: 1,
        title: "Continue",
        onClick: () => setStep(CREATE_STEP),
      }
    },
    [CREATE_STEP]: {
      title: undefined,
      render: () => <CreateForm handleGoSuccess={() => setStep(SUCCESS_STEP)} />,
      btnProps: {}
    },
    [SUCCESS_STEP]: {
      title: "Success",
      render: () => renderNicheSuccess(),
      btnProps: {
        variant: 1,
        title: "Close",
        onClick: onClose
      }
    }
  };

  const { title, render, btnProps } = stepMap[step];

  return (
    <Popup
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      popupClass="CreateNichePopup"
      btnProps={btnProps}
    >
      {render()}
    </Popup>
  );
});
